import { findClosestAdHocFilterInHierarchy, findGlobalAdHocFilterVariableByUid } from './adhoc/patchGetAdhocFilters.js';
import { findClosestGroupByInHierarchy, findGlobalGroupByVariableByUid } from './groupby/findActiveGroupByVariablesByUid.js';
import { isFilterComplete, isFilterApplicable, isGroupByFilter } from './adhoc/AdHocFiltersVariable.js';

class DrilldownDependenciesManager {
  constructor(variableDependency) {
    this._variableDependency = variableDependency;
  }
  /**
   * Find drilldown variables matching the given datasource UID.
   * When sceneObject is provided, walks up the hierarchy to find the closest match.
   * Otherwise falls back to searching the global active variable sets.
   */
  findAndSubscribeToDrilldowns(interpolatedUid, sceneObject) {
    const filtersVar = sceneObject ? findClosestAdHocFilterInHierarchy(interpolatedUid, sceneObject) : findGlobalAdHocFilterVariableByUid(interpolatedUid);
    const useAdhocGroupBy = (filtersVar == null ? void 0 : filtersVar.state.enableGroupBy) === true;
    const groupByVar = useAdhocGroupBy ? void 0 : sceneObject ? findClosestGroupByInHierarchy(interpolatedUid, sceneObject) : findGlobalGroupByVariableByUid(interpolatedUid);
    let hasChanges = false;
    if (this._adhocFiltersVar !== filtersVar) {
      this._adhocFiltersVar = filtersVar;
      hasChanges = true;
    }
    if (this._groupByVar !== groupByVar) {
      this._groupByVar = groupByVar;
      hasChanges = true;
    }
    if (hasChanges) {
      this._updateExplicitDrilldownVariableDependencies();
    }
  }
  _updateExplicitDrilldownVariableDependencies() {
    const explicitDependencies = [];
    if (this._adhocFiltersVar) {
      explicitDependencies.push(this._adhocFiltersVar.state.name);
    }
    if (this._groupByVar) {
      explicitDependencies.push(this._groupByVar.state.name);
    }
    this._variableDependency.setVariableNames(explicitDependencies);
  }
  get adHocFiltersVar() {
    return this._adhocFiltersVar;
  }
  get groupByVar() {
    return this._groupByVar;
  }
  _getAllFilters() {
    var _a;
    if (!this._adhocFiltersVar) {
      return [];
    }
    return [...(_a = this._adhocFiltersVar.state.originFilters) != null ? _a : [], ...this._adhocFiltersVar.state.filters];
  }
  /**
   * Returns only "real" ad-hoc filters, excluding groupBy entries embedded in the filters array.
   */
  getFilters() {
    return this._adhocFiltersVar ? this._getAllFilters().filter((f) => isFilterComplete(f) && isFilterApplicable(f) && !isGroupByFilter(f)) : void 0;
  }
  /**
   * Returns group-by keys. When the adhoc variable has enableGroupBy=true, extracts
   * them from the filters array (operator === 'groupBy'). Otherwise falls back to
   * the legacy GroupByVariable.
   */
  getGroupByKeys() {
    var _a;
    if ((_a = this._adhocFiltersVar) == null ? void 0 : _a.state.enableGroupBy) {
      const groupByKeys = this._getAllFilters().filter((f) => isGroupByFilter(f) && isFilterComplete(f) && isFilterApplicable(f)).map((f) => f.key);
      return groupByKeys.length > 0 ? groupByKeys : void 0;
    }
    return this._groupByVar ? this._groupByVar.getApplicableKeys() : void 0;
  }
  cleanup() {
    this._adhocFiltersVar = void 0;
    this._groupByVar = void 0;
  }
}

export { DrilldownDependenciesManager };
//# sourceMappingURL=DrilldownDependenciesManager.js.map
